import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.px-1').forEach((el) => {
  const screenHeight = window.innerHeight;
  const fromY = screenHeight > 800 ? 60 : 20;
  const toY = fromY * -1;

  gsap.fromTo(
    el,
    { y: fromY },
    {
      y: toY,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    }
  );
});

document.querySelectorAll('.px-2').forEach((el) => {
  gsap.fromTo(
    el,
    { y: 30 },
    {
      y: -30,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    }
  );
});

document.querySelectorAll('.px-2-down').forEach((el) => {
  gsap.to(el, {
    y: 50,
    ease: 'none',
    scrollTrigger: {
      trigger: el,
      start: 'top bottom',
      scrub: true,
    },
  });
});

document.querySelectorAll('.px-3').forEach((el) => {
  const screenHeight = window.innerHeight;
  const fromY = screenHeight > 800 ? 45 : 20;
  const toY = fromY * -1;

  gsap.fromTo(
    el,
    { y: fromY },
    {
      y: toY,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    }
  );
});

document.querySelectorAll('.px-4').forEach((el) => {
  const screenHeight = window.innerHeight;
  const fromY = screenHeight > 800 ? 100 : 45;
  const toY = fromY * -1;

  gsap.fromTo(
    el,
    { y: fromY },
    {
      y: toY,
      ease: 'none',
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      },
    }
  );
});
